import { warRoomClient } from './warRoomClient'
import type { Step, SingleResponse, DependencyGraph } from '../types/session.types'

export const stepService = {
  /**
   * List all steps for a session.
   */
  listBySession: (sessionId: string): Promise<{ data: Step[] }> =>
    warRoomClient.get(`sessions/${sessionId}/steps`).json(),

  /**
   * Update step status (primary action for team members).
   */
  updateStatus: (
    sessionId: string,
    stepId: string,
    payload: { status: string; note?: string }
  ): Promise<SingleResponse<Step>> =>
    warRoomClient.patch(`sessions/${sessionId}/steps/${stepId}`, { json: payload }).json(),

  /**
   * Add a dependency edge between steps.
   */
  addDependency: (
    sessionId: string,
    stepId: string,
    dependsOnStepId: string
  ): Promise<unknown> =>
    warRoomClient.post(
      `sessions/${sessionId}/steps/${stepId}/dependencies`,
      { json: { depends_on_step_id: dependsOnStepId } }
    ).json(),

  /**
   * Get dependency graph for session.
   */
  getGraph: (sessionId: string): Promise<{ data: DependencyGraph }> =>
    warRoomClient.get(`sessions/${sessionId}/graph`).json(),
}
